import React, { useState, useEffect } from 'react';
import DateInput from './DateInput';

// (임시 CSS - 변경 없음)
const modalStyles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  },
  modal: {
    background: 'white', padding: '20px', borderRadius: '8px',
    width: '90%', maxWidth: '650px'
  },
  dateInputRow: { display: 'flex', gap: '10px', marginBottom: '15px' },
  dateInput: { flex: 1, padding: '8px' },
  reasonInput: { flex: 1, padding: '8px', marginTop: '5px' },
  addButton: { padding: '8px 12px', cursor: 'pointer', background: '#007bff', color: 'white', border: 'none', alignSelf: 'flex-end' },
  dateList: { listStyle: 'none', padding: 0, maxHeight: '300px', overflowY: 'auto', border: '1px solid #eee', padding: '10px' },
  dateListItem: { display: 'flex', flexDirection: 'column', gap: '5px', padding: '8px', borderBottom: '1px solid #f0f0f0' },
  dateRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  reasonRow: { display: 'flex', gap: '5px', alignItems: 'center', fontSize: '0.9rem' },
  reasonLabel: { fontWeight: 'bold', color: '#666', minWidth: '50px' },
  reasonText: { flex: 1, padding: '4px 8px', border: '1px solid #ddd', borderRadius: '4px' },
  removeButton: { background: '#dc3545', color: 'white', border: 'none', cursor: 'pointer', padding: '2px 6px', borderRadius: '4px' },
  buttons: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' },
  saveButton: { padding: '8px 12px', cursor: 'pointer', background: '#28a745', color: 'white', border: 'none' },
  cancelButton: { padding: '8px 12px', cursor: 'pointer', background: '#6c757d', color: 'white', border: 'none' }
};

const AbsenceModal = ({ 
  isOpen, 
  onClose, 
  onSave, 
  onDatesChange, 
  currentDates = [], 
  currentReasons = {},
  workRecordId, 
  currentVersion, 
  isMonthClosed,
  // 조회 중인 연·월 (해당 달 이외 입력 제한용)
  selectedYear,
  selectedMonth,
}) => {
  const [dates, setDates] = useState(currentDates);
  const [reasons, setReasons] = useState(currentReasons);
  const [newDate, setNewDate] = useState('');
  const [newReason, setNewReason] = useState('');

  // 해당 연·월의 시작/종료일 계산 (로컬 기준으로 YYYY-MM-DD 생성)
  const formatDate = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const monthStart = (selectedYear && selectedMonth)
    ? new Date(selectedYear, selectedMonth - 1, 1)
    : null;
  const monthEnd = (selectedYear && selectedMonth)
    ? new Date(selectedYear, selectedMonth, 0) // 해당 달 마지막 날
    : null;

  const minDate = monthStart ? formatDate(monthStart) : undefined;
  const maxDate = monthEnd ? formatDate(monthEnd) : undefined;

  useEffect(() => {
    setDates(currentDates);
    setReasons(currentReasons || {});
    if (isOpen) {
      setNewDate('');
      setNewReason('');
    }
  }, [currentDates, currentReasons, isOpen]); 

  if (!isOpen) return null;

  // 날짜 추가
  const handleAddDate = () => {
    if (!newDate) return;

    // 조회 중인 연·월 범위 밖의 날짜는 차단
    if (minDate && maxDate && (newDate < minDate || newDate > maxDate)) {
      if (selectedYear && selectedMonth) {
        alert(`${selectedYear}년 ${selectedMonth}월 안의 날짜만 입력할 수 있습니다.`);
      } else {
        alert('현재 조회 중인 월 정보가 없어 날짜를 추가할 수 없습니다.');
      }
      return;
    }

    if (!dates.includes(newDate)) {
      const newDates = [...dates, newDate].sort();
      const newReasons = { ...reasons, [newDate]: newReason };
      setDates(newDates);
      setReasons(newReasons);
      setNewDate('');
      setNewReason('');
      
      if (onDatesChange) onDatesChange(newDates, newReasons);
    }
  };

  // 날짜 제거
  const handleRemoveDate = (dateToRemove) => {
    const newDates = dates.filter(date => date !== dateToRemove);
    const newReasons = { ...reasons };
    delete newReasons[dateToRemove];
    setDates(newDates);
    setReasons(newReasons);
    
    if (onDatesChange) onDatesChange(newDates, newReasons);
  };

  // 사유 변경
  const handleReasonChange = (date, reason) => {
    const newReasons = { ...reasons, [date]: reason };
    setReasons(newReasons);
    if (onDatesChange) onDatesChange(dates, newReasons);
  };

  // 저장되지 않은 데이터가 있는지 확인
  const hasUnsavedData = () => {
    if (newDate || newReason) return true;
    if (dates.length !== currentDates.length) return true;
    if (JSON.stringify(dates) !== JSON.stringify(currentDates)) return true;
    for (const d of dates) {
      if ((reasons[d] || '') !== (currentReasons[d] || '')) return true;
    }
    return false;
  };

  const handleClose = () => {
    if (hasUnsavedData()) {
      if (window.confirm('저장되지 않은 입력 내용이 있습니다. 정말 취소하시겠습니까?')) {
        onClose();
      }
    } else {
      onClose();
    }
  };

  // 저장
  const handleSave = () => {
    const absenceReasons = dates.map(date => ({
      date: date,
      reason: reasons[date] || ''
    }));
    
    onSave(workRecordId, { 
      absenceDates: dates,
      absenceReasons: absenceReasons
    });
    onClose();
  };

  return (
    <div style={modalStyles.overlay} onClick={handleClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee', paddingBottom: '10px'}}>
            <h3>결근일 관리</h3>
            <span style={{fontSize: '0.8rem', color: '#666'}}>Version: {currentVersion}</span> 
        </div>
        
        <div style={modalStyles.dateInputRow}>
          <div style={{flex: 1}}>
            <DateInput value={newDate} onChange={setNewDate} inputStyle={modalStyles.dateInput} disabled={isMonthClosed} />
            <input
              type="text"
              placeholder="결근사유 (선택사항)"
              style={modalStyles.reasonInput}
              value={newReason}
              onChange={(e) => setNewReason(e.target.value)}
              disabled={isMonthClosed}
            />
          </div>
          <button 
            type="button" 
            style={modalStyles.addButton} 
            onClick={handleAddDate}
            disabled={isMonthClosed}
          >
            추가
          </button>
        </div>
        
        <p>총 {dates.length}일 결근</p>
        <ul style={modalStyles.dateList}>
          {dates.length > 0 ? dates.map(date => (
            <li key={date} style={modalStyles.dateListItem}>
              <div style={modalStyles.dateRow}>
                <span style={{fontWeight: 'bold'}}>{date}</span>
                <button 
                  style={modalStyles.removeButton} 
                  onClick={() => handleRemoveDate(date)}
                  disabled={isMonthClosed}
                >
                  삭제
                </button>
              </div>
              <div style={modalStyles.reasonRow}>
                <span style={modalStyles.reasonLabel}>사유:</span>
                <input
                  type="text"
                  style={modalStyles.reasonText}
                  value={reasons[date] || ''}
                  onChange={(e) => handleReasonChange(date, e.target.value)}
                  placeholder="결근사유 입력"
                  disabled={isMonthClosed}
                />
              </div>
            </li>
          )) : (
            <li>결근일이 없습니다.</li>
          )}
        </ul>

        <div style={modalStyles.buttons}>
          <button type="button" style={modalStyles.cancelButton} onClick={handleClose}>취소</button>
          <button 
            type="button" 
            style={modalStyles.saveButton} 
            onClick={handleSave}
            // ⬇️ [3순위 추가] 마감 시 비활성화
            disabled={isMonthClosed}
          >
            저장하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default AbsenceModal;